import React from "react"
import TypographLink from "shared/components/TypographLink"
import Typograph from "components/Typograph"

import styles from "../styles.css"

const LegalText = () => (
  <Typograph
    htmlTag="span"
    size="extra_small"
    color="outer_space"
    weight="semi_bold"
    classNames={styles.legalText}
  >
    *Leia o regulamento completo
    <TypographLink
      to=" https://tic-cms-prod-br.s3.amazonaws.com/originals/errata-regulamento-algar-sempre-vgr-05-03-24.pdf"
      size="extra_small"
      isExternal
      target="_blank"
    >
      {` clicando aqui `}
    </TypographLink>
    CAPEMISA Capitalização S/A, Processos SUSEP nº 15414.607491/2024-13. É
    proibida a venda de Título de Capitalização a menores de dezesseis anos.
    Antes de contratar consulte previamente as condições gerais. SAC 0800 940
    1130. Ouvidoria 0800 707 4936.
  </Typograph>
)

export default LegalText



// WEBPACK FOOTER //
// ./src/scenes/AlgarForever/components/LegalText.js